'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useCallback, useEffect } from 'react'
import { useTracking } from '@/components/Tracking/useTracking'

export function TrackButtons() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { track } = useTracking()

  const parseAttributes = useCallback((params: Attr[]) => {
    return params.reduce<Record<string, string>>(
      (payload, current) => ({
        ...payload,
        ...(current.name.includes('tracking-')
          ? { [current.name.replace('tracking-', '')]: current.value }
          : {}),
      }),
      {}
    )
  }, [])

  useEffect(() => {
    const handler = (event: PointerEvent) => {
      if (event.target instanceof Element) {
        const button = event.target.closest('button') as Element | null
        if (button) {
          const attributes = parseAttributes(Array.from(button.attributes))
          if ('button-name' in attributes) {
            track('button_click', {
              buttonName: attributes['button-name'],
            })
          }
        }
      }
    }

    document.addEventListener('click', handler)

    return () => {
      document.removeEventListener('click', handler)
    }
  }, [pathname, searchParams, track, parseAttributes])

  return null
}
